import { useTranslation } from "react-i18next";

import { Column, Columns, DatePicker } from "@aviary";
import { FieldOfStudySelect } from "@shared/components/FieldOfStudySelect/FieldOfStudySelect";
import type {
  StudentInformationErrors,
  StudentInformationData,
} from "@shared/data/mutations/StudentProfileCreateMutation/StudentProfileCreate.mutation";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { l } from "@unauthenticated/oauth/locales/i18n";

interface Props {
  studentInformationData?: StudentInformationData;
  studentInformationErrors?: StudentInformationErrors;
  handleSetStudentInformationData?: (studentInfo: StudentInformationData) => void;
}

const OAuthStudentInfoFields = ({
  studentInformationData,
  studentInformationErrors,
  handleSetStudentInformationData,
}: Props) => {
  const { t } = useTranslation();
  const { tablet } = useBreakpoints();

  const isMobile = tablet.lessThan;

  const onStudentInformationChange = e => {
    const { value, id } = e.target;
    handleSetStudentInformationData({ ...studentInformationData, [id]: value });
  };

  const onDateChange = date => {
    handleSetStudentInformationData({
      ...studentInformationData,
      graduationDate: date?.toLocaleDateString("en-CA") || null,
    });
  };

  const { practitionerTypeId: practitionerTypeIdErrors, graduationDate: graduationDateErrors } =
    studentInformationErrors !== null &&
    !!studentInformationErrors.fields &&
    studentInformationErrors.fields;

  return (
    <Columns isMultiline>
      <Column columnWidth={isMobile ? 12 : 6}>
        <FieldOfStudySelect
          onChange={onStudentInformationChange}
          value={studentInformationData.practitionerTypeId}
          errors={practitionerTypeIdErrors}
        />
      </Column>

      <Column columnWidth={isMobile ? 12 : 6}>
        <DatePicker
          label={t(l.oauth.graduationDate)}
          value={new Date(studentInformationData.graduationDate ?? "")}
          variant="inline"
          onChange={onDateChange}
          isInTheFuture
          required
          errors={graduationDateErrors}
          openTo="year"
        />
      </Column>
    </Columns>
  );
};

export { OAuthStudentInfoFields };
